import React from 'react';
import "./newTr.css";

export default (props) => <tr {...props}>{props.children}</tr>;
